<!-- Employees -->
<oth-hero [contents]="testimonialsTitle"></oth-hero>
<div class="cards-wrapper">
  <app-testimonial-card
      *ngFor="let testimonial of TESTIMONIALS"
      [testimonial]="testimonial">
  </app-testimonial-card>
</div>
